import React, { useRef } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import getClasses from "../../../../utils/getClasses";
require("./CustomTextArea.scss");

export interface CustomTextAreProps {
  label: string;
  placeholder: string;
  type?: "text" | "email" | "password" | "number";
  isInvalid?: boolean;
  wrapperClass?: string;
  required?: boolean;
  defaultValue?: string;
  typeErrors?: string;
  disabled?: boolean;
  register?: UseFormRegisterReturn;
  rows?: number;
}
const CustomTextArea = (props: CustomTextAreProps) => {
  const {
    label,
    placeholder,
    defaultValue,
    isInvalid = false,
    wrapperClass = "col-lg-4",
    typeErrors = "",
    register,
    required,
    disabled,
    rows,
  } = props;
  //const ref = useRef<HTMLInputElement>(null);
  return (
    <div className={wrapperClass}>
      <div
        className={`form-group offset-lg-0 mt-1 ${getClasses({
          error: isInvalid,
        })}`}
      >
        <label
          htmlFor={label}
          className={`form-control-label ${getClasses({
            "title-red": isInvalid,
          })}`}
        >
          {label} {required && "*"}
        </label>
        <textarea
          rows={rows}
          placeholder={placeholder}
          disabled={disabled}
          defaultValue={defaultValue}
          className={`form-control custom-text-area p-md ${
            isInvalid ? "is-invalid" : ""
          }`}
          {...register}
        />
        {typeErrors && (
          <p
            className={`form-control-label  ${getClasses({
              "title-red": isInvalid,
            })}`}
          >
            <i className="icon-icons-system-notification-info message-icon"></i>
            {typeErrors}
          </p>
        )}
      </div>
    </div>
  );
};

export default CustomTextArea;
